export const type = 'closeModal';

const closeModal = payload => ({
    type,
    payload
});

export default closeModal;